import BarrelUser from "../api/model/barrels/BarrelUser";
import User from "../api/model/users/User";
import { exists } from "./object";

const groupMentionKeywords: string[] = ["everyone", "project", "organization"];

function mentionRegexFn(username: string): RegExp {
    const mentionKeywords: string = [...groupMentionKeywords, username].join("|");

    return new RegExp(`@(?:${mentionKeywords})\\b`);
}

function userRegexFn(users: BarrelUser[] = [], userDataField: keyof User = "username", regexFlags = "gi"): RegExp {
    const userData = users.map(({ user }) => user[userDataField]).filter(exists);
    const mentionKeywords: string = [...groupMentionKeywords, ...userData].join("|");

    return new RegExp(`@(?:${mentionKeywords})\\b`, regexFlags);
}

/**
 * Transforms mentions from username to userId or vice versa
 * @param users barrel users to find the user data that has been mentioned
 * @param regexFn regex to search the matches for transforming the content
 * @param userDataField source data field
 * @param textToProcess the string that contains mention
*/
function transformMentionData(
    users: BarrelUser[] = [],
    regexFn: RegExp,
    userDataField: "username" | "_id",
    textToProcess: string
) {
    function replaceMentionText(match: string) {
        const mentionMatchWithoutAt = match.substring(1);

        let mentionText = match;
        let member;

        if (users && !groupMentionKeywords.includes(mentionMatchWithoutAt)) {
            member = users.find(({ user }) => user[userDataField] === mentionMatchWithoutAt);
        }

        if (member && member.user) {
            if (userDataField === "_id") {
                mentionText = member.user.username ? `@${member.user.username}` : match;
            } else {
                mentionText = member.user._id ? `@${member.user._id}` : match;
            }
        }
        return mentionText;
    }
    return textToProcess.replace(regexFn, replaceMentionText);
}

export { mentionRegexFn, userRegexFn, groupMentionKeywords, transformMentionData };
